import { setOptInStatus, skipFavoriteDances } from "../api.js";

export async function decline(eventId, { dancerId, occurrenceDate }) {
  await setOptInStatus(eventId, { dancerId, occurrenceDate, optedIn: false });
  return skipFavoriteDances(eventId, { dancerId, occurrenceDate });
}
